import React from 'react';
import PropTypes from 'prop-types';
import "./ProvidersChart.css";
import { Chart } from "react-google-charts";
import config from '../../dashboard_config.json';

const { generalColors } = config.dashboard.charts.colors;

class ProvidersChart extends React.Component {
	state = {
		data: [["Name", "Load"]],
	};

	componentDidMount() {
		this.clearChartUrl();
	}

	componentDidUpdate(prevProps) {
		const {
			isPrimaryBroadcasting,
			focusedPrimaryId,
			broadcastDetailsJsonObject,
			isProviderChartDisplayed
		} = this.props;

		if (!isPrimaryBroadcasting && prevProps.isPrimaryBroadcasting) {
			this.clearChartUrl();
		} else if (isProviderChartDisplayed) {
			if (focusedPrimaryId !== prevProps.focusedPrimaryId) {
				this.clearChartUrl();
			} else if (broadcastDetailsJsonObject !== undefined &&
				broadcastDetailsJsonObject !== prevProps.broadcastDetailsJsonObject &&
				broadcastDetailsJsonObject["primaryId"] === focusedPrimaryId && isPrimaryBroadcasting === true) {
				this.createChartUrl(broadcastDetailsJsonObject);
			}
		}
	}

	componentWillUnmount() {
		this.clearChartUrl();
	}

	clearChartUrl() {
		if (this.state.data.length > 1) {
			this.setState({ data: [["Name", "Load"]] });
		}
	}

	createChartUrl(broadcastDetailsJsonObject) {
		let broadcastOperatorsJsonArray = broadcastDetailsJsonObject["providers"];
		let totalDeliveredPackets = broadcastDetailsJsonObject["totalDeliveredPackets"];
		if (broadcastOperatorsJsonArray === undefined) {
			this.clearChartUrl();
		} else {
			let data = [["Name", "Load"]];
			for (let index = 0; index < broadcastOperatorsJsonArray.length; index++) {
				let broadcastOperatorJsonObject = broadcastOperatorsJsonArray[index];
				let deliveredPackets = broadcastOperatorJsonObject["deliveredPackets"];
				let chartPortionParam = Math.round((deliveredPackets * 100) / totalDeliveredPackets);
				let chartNamesParam = broadcastOperatorJsonObject["providerName"];
				data.push([chartNamesParam, chartPortionParam]);
			}
			if (data.length > 1) {
				this.setState({ data });
			}
		}
	}

	render() {
		const { data } = this.state;
		const { broadcastDetails } = this.props;

		const hasData = broadcastDetails && broadcastDetails.operatorsDataArr;

		const legendData = hasData ? broadcastDetails.operatorsDataArr.map((operator, index) => {
			const latestBitrate = parseFloat(operator.operatorData[operator.operatorData.length - 1]) || 0;
			return {
				name: operator.operatorName,
				color: generalColors[index],
				bitrate: latestBitrate.toFixed(2)
			};
		}) : [];

		const totalBitrate = legendData.reduce((sum, item) => sum + parseFloat(item.bitrate), 0).toFixed(2);

		const options = {
			backgroundColor: 'transparent',
			legend: { position: 'none' },
			tooltip: { trigger: 'none' },
			chartArea: {
				left: '10%',
				top: '10%',
				width: "80%",
				height: "80%"
			},
			slices: generalColors.slice(0, data.length - 1).map(color => ({ color, offset: 0.05 })),
			pieSliceBorderColor: "#121212",
			pieSliceText: 'percentage',
			pieSliceTextStyle: { color: "#FFF", fontSize: 13, fontWeight: 'bold' },
			pieHole: 0.4, // Modern donut look
		};

		return (
			<div className="analytics-wrapper">
				<div className="premium-header">
					<div className="analytics-title">
						<i className="material-icons">pie_chart</i>
						<span>LOAD ANALYTICS</span>
					</div>
				</div>

				<div className="analytics-body">
					<div className="chart-focus-area">
						{!hasData ? (
							<div className="empty-chart-state">
								<i className="material-icons">pie_chart_outline</i>
								<span className="no-data-message">No Data Available</span>
							</div>
						) : data.length > 1 ? (
							<Chart
								chartType="PieChart"
								data={data}
								options={options}
								width={"100%"}
								height={"100%"}
							/>
						) : (
							<div className="empty-chart-state">
								<i className="material-icons">pie_chart_outline</i>
								<span className="no-data-message">Waiting for data...</span>
							</div>
						)}
					</div>

					<div className="provider-legend-sidebar">
						<div className="sidebar-header">PROVIDERS</div>
						<div className="legend-list scrollbar-hidden">
							{legendData.map((item, index) => (
								<div key={index} className="legend-item-card">
									<div
										className="status-dot"
										style={{
											backgroundColor: item.color,
											boxShadow: `0 0 6px ${item.color}44`
										}}></div>
									<div className="provider-info">
										<div className="provider-label" title={item.name}>{item.name}</div>
										<div className="provider-bitrate">{item.bitrate} Mb/s</div>
									</div>
								</div>
							))}
							{!hasData && (
								<div className="empty-legend" style={{ color: '#555', fontSize: '0.7rem', textAlign: 'center', marginTop: '20px' }}>
									No providers
								</div>
							)}
						</div>
						<div className="total-bitrate-card side-by-side">
							<div className="bitrate-sub-card target">
								<span className="total-label">TARGET</span>
								<span className="total-value">{(this.props.broadcastSettings && this.props.broadcastSettings.maxBitrate) ? parseFloat(this.props.broadcastSettings.maxBitrate).toFixed(2) : '--'} Mb/s</span>
							</div>
							<div className="bitrate-sub-card measured">
								<span className="total-label">MEASURED</span>
								<span className="total-value">{totalBitrate} Mb/s</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

ProvidersChart.propTypes = {
	screenSize: PropTypes.string.isRequired,
	isProviderChartDisplayed: PropTypes.bool.isRequired,
	broadcastDetails: PropTypes.object.isRequired,
	broadcastSettings: PropTypes.object,
};

export default ProvidersChart;
